module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-02.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-02.png
// module id = 1377
// module chunks = 0